const isAutenticated = () => {

    if (localStorage.getItem('token') == true || sessionStorage.getItem('token') == true) {
        return true;
    } else {
        return false
    }

};
export default isAutenticated;